import React from 'react';
import { MapPin, Users, Heart, Sparkles } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';

const SafetyTrust = () => {
  const { t } = useLanguage();

  const features = [
    { icon: MapPin, textKey: 'feature1' },
    { icon: Users, textKey: 'feature2' },
    { icon: Heart, textKey: 'feature3' },
    { icon: Sparkles, textKey: 'feature4' },
  ];

  return (
    <section className="py-20 bg-primary-950 text-white overflow-hidden relative">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-12">
          <div className="w-full md:w-1/2">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
              {t('welcome.title')} <br/>
              <span className="text-accent-400">{t('welcome.titleHighlight')}</span>
            </h2>
            <p className="text-lg text-blue-100 mb-8 leading-relaxed">
              {t('welcome.description')}
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((item, i) => (
                <div key={i} className="flex items-center gap-3 bg-white/5 p-4 rounded-lg backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-colors">
                  <item.icon className="w-6 h-6 text-accent-400" />
                  <span className="font-medium">{t(`welcome.${item.textKey}`)}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full md:w-1/2 relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10">
              <img 
                src="/images/bureau.jpg" 
                alt="Wownautic Office Fuengirola" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-xl font-bold italic">"{t('welcome.testimonial')}"</p>
                <p className="text-accent-400 mt-2 font-semibold">{t('welcome.testimonialAuthor')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SafetyTrust;
